export enum RecordSource {
  PUBLIC_API = "public api",
  WEB = "web",
  MOBILE = "mobile",
  BULK_EMAIL = "bulkemail",
  IMPORTS = "imports",
  INTEGRATIONS = "integrations",
  WORKFLOWS = "workflows",
  LEAD_GEN = "lead-gen",
  ZAPIER = "zapier",
}

export default RecordSource;
